import React, { Component } from "react";
//import ReactDOM from "react-dom";

//import { checkInSubmitRequest } from "../../action";
import {
  Form,
  InputGroup,
  Button,
  Container,
  Col,
} from "react-bootstrap";
//import { connect } from "react-redux";
//import { Dispatch } from "redux";
import "antd/dist/antd.css";
// import { ICheckInProps, ICheckInState } from "../../interfaces/checkin";
import {
  IMyResourcesProps,
  IResourcesState,
} from "../../interfaces/resources.interface";
/*import { AppRoutes } from "../../config";
import { IRootState } from "../../interfaces";
import { moduleDetailRequest } from "../../action/Module";
import Loader from "../../components/Loader/Loader";
import { Checkbox } from "antd";
import { ConfirmBox } from "../../helper/SweetAlert";
import { toast } from "react-toastify";
import { Menu } from "antd";
import { checkInReducer } from "../../reducer/CheckIn";
import DateFnsUtils from "@date-io/date-fns";
import PropTypes from "prop-types";

import { DatePicker } from "antd";
import moment from "moment";
import { containerCSS } from "react-select/src/components/containers";*/
// import { fontWeight } from "@mui/system";
//import { Item } from "react-bootstrap/lib/Breadcrumb";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import podCastImage from "../../assets/images/resources page/podcast_icon_resources_page-removebg-preview.png";
import videoImageIcon from "../../assets/images/resources page/video_icon_-_resource_page-removebg-preview.png";
import recommendedReadingPage from "../../assets/images/resources page/recommended_reading_transparent_-_resources_page-removebg-preview.png";
import retroToolsAndResources from "../../assets/images/resources page/retro_tools_transparent_-_resources_page-removebg-preview (1).png";
import EnergizersAndIcebreakers from "../../assets/images/resources page/icebreaker_icon_transparent_-_resources_page-removebg-preview.png";
const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 3, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 2, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
};

const resourcesData = [
  {
    title: "Podcasts",
    iconType: podCastImage,
  },

  {
    title: "Videos",
    iconType: videoImageIcon,
  },

  {
    title: "Recommended Reading",
    iconType: recommendedReadingPage,
  },
  {
    title: "Retrospective Tools & Addtional Resources",
    iconType: retroToolsAndResources,
  },
  {
    title: "Energisers and Ice Breakers",
    iconType: EnergizersAndIcebreakers,
  },
];
class Resources extends Component<IMyResourcesProps, IResourcesState> {
  constructor(props: IMyResourcesProps) {
    super(props);
    this.state = {
      resourcesname: "",
    };
  }

  componentDidMount() {}

  render() {
    return (
      <>
        <>
          <div className="main-section module-custom-main" id="right-container">
            <Col md={12} lg={12}>
              <Container>
                <div className="title video-search">
                  <div className="row">
                    <div className="filter-video-section">
                      <h1 className="video-title">
                        Resources
                        <span className="border-heading"></span>
                      </h1>
                      <div className="search-section">
                        <Form
                        // onSubmit={this.handleSubmit}
                        >
                          <Form.Group controlId="filter" className="mb-0">
                            <span className="video-search-section">
                              {" "}
                              <Button variant="outline-info" type="submit">
                                {" "}
                                <i className="fa fa-search"></i>
                              </Button>
                            </span>
                            <InputGroup>
                              <input
                                type={"text"}
                                placeholder="Search"
                                aria-label="Recipient's username"
                                aria-describedby="basic-addon2"
                                name={"search"}
                                // value={search}
                                className={"form-control floating-input"}
                                // onChange={this.handleChange}
                              />
                            </InputGroup>
                          </Form.Group>
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ height: "420px" }}>
                  <Carousel
                    swipeable={false}
                    draggable={false}
                    showDots={false}
                    responsive={responsive}
                    ssr={true} // means to render carousel on server-side.
                    infinite={true}
                    keyBoardControl={true}
                    customTransition="all .5"
                    containerClass="carousel-container"
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                    dotListClass="custom-dot-list-style"
                    itemClass="carousel-item-padding-40-px"
                  >
                    {resourcesData.map((item) => {
                      return (
                        <>
                          <div
                            style={{
                              cursor: "pointer",
                              padding: "50px 0px 50px 0px",
                              display: "flex",

                              flexDirection: "column",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  height: "204px",
                                  width: "215px",
                                  border: "6px solid rgb(205 166 37)",
                                  borderRadius: "50%",
                                }}
                              >
                                <img
                                  style={{
                                    marginTop: "16px",

                                    height: "150px",
                                  }}
                                  src={item.iconType} alt=""
                                />
                              </div>
                            </div>
                            <h3
                              style={{
                                // paddingRight: "43px",

                                textAlign: "center",
                              }}
                            >
                              {item.title}
                            </h3>
                          </div>
                        </>
                      );
                    })}
                  </Carousel>
                </div>
              </Container>
            </Col>
          </div>
        </>
      </>
    );
  }
}

// const mapStateToProps: any = (state: IRootState) => ({
//   ResourcesReducer: state.resourcesReducer,
// });

// const mapDispatchToProps = (dispatch: Dispatch) => {
//   return {
//     //   helpfaqData: (data: any) => {
//     //     dispatch(helpFaqRequest(data));
//     //   },
//   };
// };

// export default connect(mapStateToProps, mapDispatchToProps)(Resources);
export default Resources;
